import { render, staticRenderFns } from "./BoardListBasic.vue?vue&type=template&id=16b40195"
import script from "./BoardListBasic.vue?vue&type=script&lang=js"
export * from "./BoardListBasic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports